import cyberSecurityData from '../../apis/cyberSecurityData';

export const setEDRTimeRange = (time) => {
    return {
        type: 'SET_EDR_TIME_RANGE',
        payload: time
    };
};

export const setInsightsIDRSelectedLogSets = (sets) => {
    return {
        type: 'SET_INSIGHTS_IDR_SELECTED_LOG_SETS',
        payload: sets
    };
};

export const setCrowdStrikeDomain = (domain) => {
    return {
        type: 'SET_CROWDSTRIKE_DOMAIN',
        payload: domain
    };
};

export const setShowCrowdStrikeDomainSettingsModal = (showModal) => {
    return {
        type: 'SET_CROWDSTRIKE_DOMAIN_SHOW_SETTINGS_MODAL',
        payload: showModal
    };
};

export const setSelectedEDR = (edrName) => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'SET_SELECTED_EDR',
            payload: edrName
        });

        // if edrName === 'insights-idr' we will fetch the available log sets if not fetched already
        const availableLogSets = getState().detections.edr.settings.availableLogSets;

        if (edrName === 'insights-idr' && availableLogSets.length === 0) {
            try {
                const response = await cyberSecurityData.get('/detections/get-insights-idr-logsets', {
                    headers: {
                        Authorization: 'Bearer ' + getState().accessToken
                    }
                });

                if (response.data.logSets) {
                    const sets = response.data.logSets.map(set => {
                        return {
                            label: set.name,
                            value: set.id
                        };
                    });
                    dispatch({
                        type: 'SET_INSIGHTS_IDR_AVAILABLE_LOG_SETS',
                        payload: sets
                    });

                    // setting the selected log sets to "Endpoint Activity" by default
                    const defaultLogSets = sets.filter(set => set.label === 'Endpoint Activity');
                    if (defaultLogSets.length > 0) {
                        dispatch(setInsightsIDRSelectedLogSets(defaultLogSets));
                    }
                }

            } catch (error) {
                console.log({ error: error.message });
            }
        }

    } catch (error) {
        console.log({ error: error.message });
    }
};

export const edrSettingsValidation = () => async (dispatch, getState) => {
    try {
        const validationResult = {};

        const selectedEDR = getState().dashboard_Main.selectedEDR;
        if (selectedEDR === 'insights-idr') {
            const logSets = getState().detections.edr.settings.insightsIDRSelectedLogSets;
            if (logSets.length === 0) {
                validationResult.error = 'Please select at least one log set to search';
            }
        }

        return validationResult;
    } catch (error) {
        console.log({ error: error.message });
    }
};

// -----------------------------------------  EDR SCAN RESULTS ------------------------------------------

export const setEDRScanResults = (payload) => {
    return {
        type: 'SET_EDR_SCAN_RESULTS',
        payload
    };
};
export const setShowEDRScanResults = (payload) => {
    return {
        type: 'SET_SHOW_EDR_SCAN_RESULTS',
        payload
    };
};

export const setBreachEDRScanResults = (payload) => {
    return {
        type: 'SET_BREACH_EDR_SCAN_RESULTS',
        payload
    };
};

export const resetEDRScanResults = () => {
    return {
        type: 'RESET_EDR_SCAN_RESULTS'
    };
};
export const setEDRScanning = (boolean) => {
    return {
        type: 'SET_EDR_SCANNING',
        payload: boolean
    };
};
export const setEDRItemsBeingScanned = (ids) => {
    return {
        type: 'SET_EDR_ITEMS_BEING_SCANNED',
        payload: ids
    };
};
